import {
  LOAD_SESSION_REPORTS,
  STORE_SESSION_REPORTS,
  CLEAR_SESSION_REPORTS,
  SESSION_REPORTS_FAILED,
  STORE_AUDIT_LOG,
  STORE_OWNER_AUDIT_SETTINGS,
  STORE_DUPLICATE_SCORES,
  RECORD_LOCAL_DECISION,
  CLEAR_LOCAL_DECISIONS,
} from '../../constants/employeeSessionV2';

const initialState = {
  sessionData: null,
  loadingSessionReports: false,
  auditLog: [],
  ownerSettings: {
    requireReviewEveryBonus: true,
    mandatoryAuditMode: false,
    requireDecisionBeforeComplete: false,
    ownerAlertEditThreshold: 5,
  },
  duplicateScores: [],
  // Map keyed as `${entityType}:${entityId}` → 'APPROVED' | 'FLAGGED'.
  // Mirrors the server-side AuditDecision record but lets the UI render
  // instantly while the saga posts in the background.
  localDecisions: {},
};

export default function employeeSessionV2(state = initialState, action) {
  switch (action.type) {
    case LOAD_SESSION_REPORTS:
      return { ...state, loadingSessionReports: true };
    case STORE_SESSION_REPORTS: {
      const data = action.data || {};
      const decisionMap = {};
      (data.decisions || []).forEach((d) => {
        decisionMap[`${d.entityType}:${d.entityId}`] = d.decision;
      });
      return {
        ...state,
        sessionData: data,
        loadingSessionReports: false,
        auditLog: data.auditLog || [],
        ownerSettings: data.ownerSettings || state.ownerSettings,
        localDecisions: decisionMap,
      };
    }
    case SESSION_REPORTS_FAILED:
      return { ...state, loadingSessionReports: false };
    case CLEAR_SESSION_REPORTS:
      return { ...initialState };
    case STORE_AUDIT_LOG:
      return { ...state, auditLog: action.logs };
    case STORE_OWNER_AUDIT_SETTINGS:
      return {
        ...state,
        ownerSettings: action.settings || state.ownerSettings,
      };
    case STORE_DUPLICATE_SCORES:
      return { ...state, duplicateScores: action.scores };
    case RECORD_LOCAL_DECISION:
      return {
        ...state,
        localDecisions: {
          ...state.localDecisions,
          [`${action.entityType}:${action.entityId}`]: action.decision,
        },
      };
    case CLEAR_LOCAL_DECISIONS:
      return { ...state, localDecisions: {} };
    default:
      return state;
  }
}
